import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import InsuranceDropdown from './InsuranceDropdown';
import LoansDropdown from './LoansDropdown';
import AboutUsDropdown from './AboutUsDropdown';
import './Header.css';

const Header = () => {
  const [aboutUsOpen, setAboutUsOpen] = useState(false);
  const [insuranceOpen, setInsuranceOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [loansOpen, setLoansOpen] = useState(false);
  // Mobile dropdown states
  const [mobileLoansOpen, setMobileLoansOpen] = useState(false);
  const [mobileInsuranceOpen, setMobileInsuranceOpen] = useState(false);
  const [mobileAboutUsOpen, setMobileAboutUsOpen] = useState(false);
  const timeoutRef = useRef(null);
  const insuranceTimeoutRef = useRef(null);
  const loansTimeoutRef = useRef(null);

  const handleLoansMouseEnter = () => {
    if (loansTimeoutRef.current) clearTimeout(loansTimeoutRef.current);
    setInsuranceOpen(false);
    setAboutUsOpen(false);
    setLoansOpen(true);
  };

  const handleLoansMouseLeave = () => {
    loansTimeoutRef.current = setTimeout(() => {
      setLoansOpen(false);
    }, 200);
  };

  const handleLoansClick = () => {
    if (loansOpen) {
      setLoansOpen(false);
    } else {
      handleLoansMouseEnter();
    }
  };

  const handleMouseEnter = () => { // About Us
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setLoansOpen(false);
    setInsuranceOpen(false);
    setAboutUsOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setAboutUsOpen(false);
    }, 200);
  };

  const handleAboutUsClick = () => {
    if (aboutUsOpen) {
      setAboutUsOpen(false);
    } else {
      handleMouseEnter();
    }
  };

  const handleInsuranceMouseEnter = () => {
    if (insuranceTimeoutRef.current) clearTimeout(insuranceTimeoutRef.current);
    setLoansOpen(false);
    setAboutUsOpen(false);
    setInsuranceOpen(true);
  };

  const handleInsuranceMouseLeave = () => {
    insuranceTimeoutRef.current = setTimeout(() => {
      setInsuranceOpen(false);
    }, 200);
  };

  const handleInsuranceClick = () => {
    if (insuranceOpen) {
      setInsuranceOpen(false);
    } else {
      handleInsuranceMouseEnter();
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <>


      <header className="main-header">
        <div className="header-content">
          <div className="logo">
            <div className="logo-icon"></div>
            <div className="logo-text">
              <span className="logo-name">WE CARE FINSERV</span>
            </div>
          </div>

          <nav className="main-nav">
            <div
              className="nav-item nav-dropdown"
              onMouseEnter={handleLoansMouseEnter}
              onMouseLeave={handleLoansMouseLeave}
              onClick={handleLoansClick}
            >
              <span>Loans</span>
              <span className="dropdown-arrow"></span>

              <LoansDropdown
                isOpen={loansOpen}
                onMouseEnter={handleLoansMouseEnter}
                onMouseLeave={handleLoansMouseLeave}
              />
            </div>
            <div
              className="nav-item nav-dropdown"
              onMouseEnter={handleInsuranceMouseEnter}
              onMouseLeave={handleInsuranceMouseLeave}
              onClick={handleInsuranceClick}
            >
              <span>Insurance</span>
              <span className="dropdown-arrow"></span>

              <InsuranceDropdown
                isOpen={insuranceOpen}
                onMouseEnter={handleInsuranceMouseEnter}
                onMouseLeave={handleInsuranceMouseLeave}
              />
            </div>
            <div
              className="nav-item nav-dropdown"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              onClick={handleAboutUsClick}
            >
              <span>About Us</span>
              <span className="dropdown-arrow"></span>

              <AboutUsDropdown
                isOpen={aboutUsOpen}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              />
            </div>

            <Link to="/careers" className="nav-item">
              <span>Careers</span>
            </Link>

            {/* Login Button */}
            <Link to="/login" className="login-btn">
              <span>Login</span>
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className={`mobile-menu-btn ${mobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </header>

      {/* Mobile Navigation Overlay */}
      <div
        className={`mobile-nav-overlay ${mobileMenuOpen ? 'active' : ''}`}
        onClick={closeMobileMenu}
      ></div>

      {/* Mobile Navigation Menu */}
      <div className={`mobile-nav ${mobileMenuOpen ? 'active' : ''}`}>
        <button className="mobile-nav-close" onClick={closeMobileMenu}>×</button>

        {/* Loans with dropdown */}
        <div className="mobile-nav-item-wrapper">
          <div
            className={`mobile-nav-item ${mobileLoansOpen ? 'active' : ''}`}
            onClick={() => setMobileLoansOpen(!mobileLoansOpen)}
          >
            <span>Loans</span>
            <span className={`mobile-dropdown-arrow ${mobileLoansOpen ? 'open' : ''}`}>›</span>
          </div>
          {mobileLoansOpen && (
            <div className="mobile-dropdown-content">
              <div className="mobile-dropdown-category">Housing Finance</div>
              <Link to="/#home-loan" className="mobile-dropdown-item" onClick={closeMobileMenu}>🏠 Home Loan</Link>
              <Link to="/#balance-transfer" className="mobile-dropdown-item" onClick={closeMobileMenu}>💸 Balance Transfer</Link>
              <Link to="/#top-up" className="mobile-dropdown-item" onClick={closeMobileMenu}>➕ Top-Up Home Loan</Link>
              <Link to="/#lap-housing" className="mobile-dropdown-item" onClick={closeMobileMenu}>🏡 Loan Against Property</Link>

              <div className="mobile-dropdown-category">Personal Finance</div>
              <Link to="/#personal-loan" className="mobile-dropdown-item" onClick={closeMobileMenu}>⏱️ Personal Loan</Link>
              <Link to="/#flexi-loan" className="mobile-dropdown-item" onClick={closeMobileMenu}>🐷 Flexi Loan</Link>
              <Link to="/#instant-personal-loan" className="mobile-dropdown-item" onClick={closeMobileMenu}>💸 Instant Personal Loan</Link>

              <div className="mobile-dropdown-category">SME & Business</div>
              <Link to="/#secured-business-loan" className="mobile-dropdown-item" onClick={closeMobileMenu}>🔒 Secured Business Loan</Link>
              <Link to="/#line-of-credit" className="mobile-dropdown-item" onClick={closeMobileMenu}>💳 Line Of Credit</Link>
              <Link to="/#working-capital" className="mobile-dropdown-item" onClick={closeMobileMenu}>💼 Working Capital Loan</Link>
              <Link to="/#supply-chain" className="mobile-dropdown-item" onClick={closeMobileMenu}>🚚 Supply Chain Finance</Link>
              <Link to="/#unsecured-business-loan" className="mobile-dropdown-item" onClick={closeMobileMenu}>🔓 Unsecured Business Loan</Link>

              <div className="mobile-dropdown-category">Loan Against Property</div>
              <Link to="/#lap" className="mobile-dropdown-item" onClick={closeMobileMenu}>🏡 Loan Against Property</Link>
              <Link to="/#construction-finance" className="mobile-dropdown-item" onClick={closeMobileMenu}>🏗️ Construction Finance</Link>
              <Link to="/#commercial-property-purchase" className="mobile-dropdown-item" onClick={closeMobileMenu}>🏢 Commercial Property</Link>
              <Link to="/#lease-rental-discounting" className="mobile-dropdown-item" onClick={closeMobileMenu}>🤝 Lease Rental Discounting</Link>
            </div>
          )}
        </div>

        {/* Insurance with dropdown */}
        <div className="mobile-nav-item-wrapper">
          <div
            className={`mobile-nav-item ${mobileInsuranceOpen ? 'active' : ''}`}
            onClick={() => setMobileInsuranceOpen(!mobileInsuranceOpen)}
          >
            <span>Insurance</span>
            <span className={`mobile-dropdown-arrow ${mobileInsuranceOpen ? 'open' : ''}`}>›</span>
          </div>
          {mobileInsuranceOpen && (
            <div className="mobile-dropdown-content">
              <div className="mobile-dropdown-category">Life Insurance</div>
              <Link to="/#term-insurance" className="mobile-dropdown-item" onClick={closeMobileMenu}>🛡️ Term Insurance</Link>
              <Link to="/#retirement-plans" className="mobile-dropdown-item" onClick={closeMobileMenu}>🍵 Retirement Plans</Link>
              <Link to="/#savings-plans" className="mobile-dropdown-item" onClick={closeMobileMenu}>🐷 Savings Plans</Link>
              <Link to="/#ulip-plans" className="mobile-dropdown-item" onClick={closeMobileMenu}>💰 ULIP Plans</Link>

              <div className="mobile-dropdown-category">Health Insurance</div>
              <Link to="/#health-wellness" className="mobile-dropdown-item" onClick={closeMobileMenu}>♡ Health & Wellness</Link>
              <Link to="/#super-top-up" className="mobile-dropdown-item" onClick={closeMobileMenu}>🎗️ Super Top-up Plans</Link>
              <Link to="/#health-saver" className="mobile-dropdown-item" onClick={closeMobileMenu}>💳 Health Saver Card</Link>

              <div className="mobile-dropdown-category">Motor Insurance</div>
              <Link to="/#bike-insurance" className="mobile-dropdown-item" onClick={closeMobileMenu}>🏍️ Bike Insurance</Link>
              <Link to="/#car-insurance" className="mobile-dropdown-item" onClick={closeMobileMenu}>🚗 Car Insurance</Link>
            </div>
          )}
        </div>

        {/* About Us with dropdown */}
        <div className="mobile-nav-item-wrapper">
          <div
            className={`mobile-nav-item ${mobileAboutUsOpen ? 'active' : ''}`}
            onClick={() => setMobileAboutUsOpen(!mobileAboutUsOpen)}
          >
            <span>About Us</span>
            <span className={`mobile-dropdown-arrow ${mobileAboutUsOpen ? 'open' : ''}`}>›</span>
          </div>
          {mobileAboutUsOpen && (
            <div className="mobile-dropdown-content">
              <div className="mobile-dropdown-category">WCFL</div>
              <Link to="/company-profile" className="mobile-dropdown-item" onClick={closeMobileMenu}>Company Profile</Link>
              <span className="mobile-dropdown-item disabled">Leadership Team (Coming Soon)</span>
              <Link to="/vision-values" className="mobile-dropdown-item" onClick={closeMobileMenu}>Our Vision and Values</Link>
              <span className="mobile-dropdown-item disabled">Our Achievements (Coming Soon)</span>
              <Link to="/careers" className="mobile-dropdown-item" onClick={closeMobileMenu}>Career</Link>

              <div className="mobile-dropdown-category">Policy & Disclosure</div>
              <span className="mobile-dropdown-item disabled">Digital Referral Partners (Coming Soon)</span>
              <Link to="/terms-and-conditions" className="mobile-dropdown-item" onClick={closeMobileMenu}>Terms & Conditions</Link>
            </div>
          )}
        </div>

        {/* Careers link */}
        <Link to="/careers" className="mobile-nav-item" onClick={closeMobileMenu}>
          <span>Careers</span>
        </Link>

        {/* Login button */}
        <Link to="/login" className="mobile-login-btn" onClick={closeMobileMenu}>
          <span>Login</span>
        </Link>
      </div>
    </>
  );
};

export default Header;
